import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import EventPendingView from '../components/content/event/EventPendingView';
import BestOf from '../components/content/event/BestOf';
import EventOnlineView from '../components/content/event/EventOnlineView';
import PaymentMethodView from '../components/content/PaymentMethodView';
import PastEventInformation from '../components/content/event/PastEventInformation';
import Pricelist from '../components/content/event/Pricelist';

import fetchBestofConfig from '../utils/fetchBestofConfig';

const PENDING_STATE = 'reminder';

class EventPage extends Component {
  constructor(props) {
    super(props);

    const { event } = props.viewer;

    var initialSelectedTab;
    switch(true) {
      case event.searchByFaceAsFeature:
        initialSelectedTab = 3;
        break;
      default:
        initialSelectedTab = 1;
    }

    var pastEventNotificationHorizon = new Date();
    pastEventNotificationHorizon.setDate(pastEventNotificationHorizon.getDate() - 90);
    var currentEventDate = new Date(event.beginsAt);
    var showPastEventNotification = currentEventDate < pastEventNotificationHorizon;

    this.state = {
      showPastEventNotification: showPastEventNotification,
      shouldExpandBestOf: props.match.params.bestof ? true : false,
      extendedSearchSelectedTab: initialSelectedTab,
      extendedSearchExpand: false,
      bestOfAvailable: false,
    };
  }

  componentDidMount() {
    fetchBestofConfig(this.props.viewer.event.sgId, 'HEAD').then(config => {
      this.setState({ bestOfAvailable: config.isAvailable });
    });
  }

  handleClosePastEventNotification = () => {
    this.setState({ showPastEventNotification: false });
  };

  handleExtendedSearchTabChanged = (event, value) => {
    this.setState({
      extendedSearchSelectedTab: value,
      extendedSearchExpand: true,
    });
  };

  handleExtendedSearchExpand = () => {
    this.setState(prevState => ({
      extendedSearchExpand: !prevState.extendedSearchExpand,
    }));
  };

  handleExpandBestof = () => {
    this.setState({
      shouldExpandBestOf: true,
    });
  };

  render() {
    const {
      shouldExpandBestOf,
      showPastEventNotification,
      extendedSearchSelectedTab,
      extendedSearchExpand,
      bestOfAvailable,
    } = this.state;
    const { viewer } = this.props;
    const { event } = viewer;

    // In case a user navigates to an old event, we make a redirect to the archive website
    if (event.legacy) {
      window.location.href = `https://archive.sportograf.com/shop/event/${event.sgId}`;
      return null;
    }

    // In case a user navigates directly over the url, it is necessary to check if the
    // event has subevents. If so, forward him to the appropriate page.
    if (event.subEvents.length > 0) {
      return <Redirect to={`/event/${event.sgId}/subevents`} />;
    }

    const eventOnline = event.state !== PENDING_STATE;

    return (
      <div className="container-960 container-page">
        {event.successorEvent && showPastEventNotification && (
          <PastEventInformation
            eventname={event.name}
            currentEventDate={event.beginsAt}
            successorEvent={event.successorEvent}
            onRequestClose={this.handleClosePastEventNotification}
          />
        )}
        {!eventOnline && (
          <EventPendingView
            pendingEvent={event}
            onExpandBestof={this.handleExpandBestof}
            bestOfAvailable={bestOfAvailable}
          />
        )}
        {eventOnline && (
          <EventOnlineView
            onlineEvent={event}
            onExpandBestof={this.handleExpandBestof}
            bestOfAvailable={bestOfAvailable}
            extendedSearchSelectedTab={extendedSearchSelectedTab}
            extendedSearchExpand={extendedSearchExpand}
            hasGpsSearchTab={event.gps}
            hasFaceSearchTab={event.searchByFaceAsFeature && !event.searchByFace}
            hasSmartSearchTab={false}
            hasExtendedSearch={!event.secondFactorType}
            onExtendedSearchTabChange={this.handleExtendedSearchTabChanged}
            onExtendedSearchExpand={this.handleExtendedSearchExpand}
          />
        )}
        {bestOfAvailable && (
          <BestOf
            sgId={event.sgId}
            expanded={!eventOnline}
            shouldExpandBestOf={shouldExpandBestOf}
          />
        )}
        {eventOnline && <Pricelist offer={event} />}
        <PaymentMethodView />
      </div>
    );
  }
}

EventPage.propTypes = {
  match: PropTypes.object,
  viewer: PropTypes.object,
};

export { EventPage };

export default createFragmentContainer(EventPage, {
  viewer: graphql`
    fragment EventPage_viewer on Viewer {
      event(id: $eventId, language: $language) {
        id
        sgId
        beginsAt
        gps
	searchByFace
	searchByFaceAsFeature
        name
        legacy
        secondFactorType {
          type
        }
        state
        subEvents {
          id
        }
        successorEvent {
          ...PastEventInformation_successorEvent
        }
        ...EventPendingView_pendingEvent
        ...EventOnlineView_onlineEvent
        ...Pricelist_offer
      }
    }
  `,
});
